






































import '@/assets/scss/pages/page-auth.scss';
import { Util } from '@/utils/Util';
import { IFeedback } from 'admiral-core';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '@/components/common/Avatar.vue';
import Rating from '@/views/pages/admin/Rating.vue';
@Component({
  components: {
    Avatar,
    Rating,
  },
})
export default class FeedbackTable extends Vue {
  @Prop({ type: Array, required: true })
  feedbacks!: IFeedback[];

  formatDate(date: Date) {
    return Util.formatDate(date);
  }
}
